import { render, staticRenderFns } from "./mobilename.vue?vue&type=template&id=4b7c13e3&"
import script from "./mobilename.vue?vue&type=script&lang=js&"
export * from "./mobilename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VImg,VToolbarTitle})
